import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

function Header() {
  return (
    <div className='headerComponent'>
        <div className="contents">
            <div className="rowContents">
                <p>Ressources Humaines</p>
                <Link to="/admin/newResponsable">
                    <Button className='submitButton'> Ajouter un responsable </Button>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default Header
